export default "__VITE_ASSET__6c9bc409__"